import * as d3 from 'd3';

export default {
  async create(
    el,
    data,
    {
      veryPositiveColour = 'green',
      positiveColour = 'blue',
      negativeColour = 'yellow',
      neutralColour = '#eee',
      veryNegativeColour = 'red',
    },
  ) {
    //this was in a constructor
    this.el = el;
    this.data = data.content.data
      .sort((a, b) => a > b)
      .map((val, idx) => {
        return {
          score: val,
          index: idx,
        };
      });

    this.height = 60;
    this.width = el.getBoundingClientRect().width;

    this.veryPositiveColour = veryPositiveColour;
    this.positiveColour = positiveColour;
    this.negativeColour = negativeColour;
    this.neutralColour = neutralColour;
    this.veryNegativeColour = veryNegativeColour;

    // create chart
    const margin = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    };
    const chart = d3
      .select(this.el)
      .attr('width', this.width)
      .attr('height', this.height + margin.top + margin.bottom)
      .attr('viewBox', '0 0 ' + this.width + ' ' + this.height)
      .append('g');
    const labelBarHeight = 4;
    const positiveHeight = (this.height - labelBarHeight) / 2;

    /**
     * Scales
     */
    const x = d3
      .scaleBand()
      .domain(this.data.map((el) => el.index))
      .range([margin.left, this.width - margin.right])
      .paddingOuter(0.5)
      .align(0.5);

    const y = d3.scaleLinear().domain([0, 1]).range([0, positiveHeight]);

    /**
     * Labels setup
     */
    // const labelBar = chart
    //   .append('g')
    //   .attr('transform', 'translate(0, ' + (this.height / 2 - labelBarHeight / 2) + ')');

    // const bgRects = labelBar
    //   .selectAll('rect')
    //   .data(this.data)
    //   .enter()
    //   .append('rect')
    //   .attr('fill', 'white')
    //   .attr('stroke', 'grey')
    //   .attr('height', labelBarHeight)
    //   .attr('width', x.bandwidth())
    //   .attr('x', (d) => x(d.index));

    /**
     * Adding bars
     */
    const positive = chart.append('g');

    positive
      .selectAll('rect')
      .data(this.data.filter((d) => d.score > 0))
      .enter()
      .append('rect')
      .attr('fill', (d) => this.colorLabel(d.score))
      .attr('height', (d) => y(d.score))
      .attr('width', x.bandwidth())
      .attr('x', (i) => x(i.index))
      .attr('transform', (d) => 'translate(0, ' + (positiveHeight - y(d.score)) + ')');

    const negative = chart
      .append('g')
      .attr('transform', 'translate(0, ' + (positiveHeight + labelBarHeight) + ')');

    negative
      .selectAll('rect')
      .data(this.data.filter((d) => d.score < 0))
      .enter()
      .append('rect')
      .attr('fill', (d) => this.colorLabel(d.score))
      .attr('height', (d) => y(Math.abs(d.score)))
      .attr('width', x.bandwidth())
      .attr('x', (i) => x(i.index));
  },

  colorLabel(score) {
    if (score <= -0.75) {
      return this.veryNegativeColour;
    } else if (score > -0.75 && score <= -0.25) {
      return this.negativeColour;
    } else if (score > -0.25 && score <= 0.25) {
      return this.neutralColour;
    } else if (score > 0.25 && score <= 0.75) {
      return this.positiveColour;
    } else if (score > 0.75) {
      return this.veryPositiveColour;
    }
  },

  empty() {
    const parent = d3.select(this.el);
    parent.selectAll('*').remove();
    parent.attr('width', null).attr('viewBox', null);
  },
};
